import { useEffect } from 'react';

import { useMessages } from '../i18n';

/**
 * Names the page in the browser tab, its history and a bookmark (docs/15 §7):
 * the parts from the most specific out, then the product with this panel's tag —
 * "Hesaplar — entegrepazar Admin Panel". The tag is what tells this tab from a
 * seller panel's beside it before either is opened. A part not known yet, such
 * as a record still loading, is left out rather than written as a blank.
 *
 * Every page calls it, and lint holds that. Leaving a page puts the product's
 * name back alone, so a screen that names nothing — the moment before the
 * session is known — never keeps the title of the page before it.
 */
export function usePageTitle(...parts: Array<string | null | undefined>): void {
    // The product's name is a name rather than a word, the same in every language, as on the logo.
    const product = `entegrepazar ${useMessages().panelName}`;
    const title = parts.filter((part): part is string => Boolean(part)).join(' · ');

    useEffect(() => {
        document.title = title ? `${title} — ${product}` : product;
        return () => {
            document.title = product;
        };
    }, [title, product]);
}
